import moment from 'moment'
import PlatformActions from './PlatformActions'

export default class PLAYTECHLIVEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'LIVE',
      gameCode: 'PLAYTECH-LIVE-002',
      platform: 'PLAYTECH',
    }

    this.gameName = 'Speed Baccarat Emperor'

    this.constantGameInfo = {
      betDetails: {
        tableCoverage: 45,
        betType: 'MAIN_BET',
      },
      tableId: 'bal_emperorbaccarat',
      liveTableDetails: {
        launchAlias: 'bal_emperorbaccarat',
        tableId: '10291',
        tableName: this.gameName,
      },
    }

    this.roundIdPrefix = 'live'
    this.roundIdSufix = 'd08d86cb'

    // Multi Bets
    this.constantTxnData_multiBets = {
      gameType: 'LIVE',
      gameCode: 'PLAYTECH-LIVE-150',
      platform: 'PLAYTECH',
    }

    this.gameName_multiBets = "Casino Hold'em"

    this.constantGameInfo_multiBets = {
      betDetails: {
        tableCoverage: 0,
        betType: 'MAIN_BET',
      },
      tableId: 'chel_casinoholdem',
      liveTableDetails: {
        launchAlias: 'chel_casinoholdem',
        tableId: '9483',
        tableName: 'UAT Casino Hold’em',
      },
    }

    this.roundIdSufix_multiBets = '4963b278'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
      isMultiBets,
    }) => {
      const roundIdSufix = isMultiBets ? this.roundIdSufix_multiBets : this.roundIdSufix
      return {
        ...(isMultiBets ? this.constantTxnData_multiBets : this.constantTxnData),
        gameName: isMultiBets ? this.gameName_multiBets : this.gameName,
        userId,
        platformTxId: `${txnId}`, // 116314294
        roundId: `${this.roundIdPrefix}_${roundId}#${roundIdSufix}`, // live_87617990091#d08d86cb
        betType: null,
        currency,
        betTime, // 2026-04-16T15:56:29.000+08:00
        betAmount,
        jackpotBetAmount: 0,
        gameInfo: isMultiBets ? this.constantGameInfo_multiBets : this.constantGameInfo,
        ...(supportPremium && { isPremium: false }),
      }
    })

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      settleTxnId,
      roundId,
      updateTime,
      betTime,
      txTime,
      turnover,
      betAmount,
      winAmount,
      isMultiBets,
      betSelections,
      isEndRound = true,
    }) => {
      const roundIdSufix = isMultiBets ? this.roundIdSufix_multiBets : this.roundIdSufix
      return {
        ...(isMultiBets ? this.constantTxnData_multiBets : this.constantTxnData),
        gameName: isMultiBets ? this.gameName_multiBets : this.gameName,
        userId,
        platformTxId: winAmount ? `${settleTxnId}` : `${this.roundIdPrefix}_${roundId}#${roundIdSufix}`, // WIN: 116314299(與bet.txnId不同), LOSE: live_87617990093#d08d86cb(=roundId)
        refPlatformTxId: null,
        settleType: 'roundId',
        updateTime, // 2026-04-16T15:56:41.006+08:00
        roundId: `${this.roundIdPrefix}_${roundId}#${roundIdSufix}`, // live_87617990091#d08d86cb
        betType: null,
        betTime, // 2026-04-16T15:56:29.000+08:00
        txTime, // 2026-04-16T15:56:40.000+08:00
        turnover,
        betAmount,
        winAmount,
        jackpotWinAmount: 0,
        gameInfo: {
          ...(isMultiBets ? this.constantGameInfo_multiBets : this.constantGameInfo),
          isEndRound: `${isEndRound}`,
          ...(winAmount && {
            pay: {
              transactionCode: settleTxnId,
              transactionDate: moment(txTime).utcOffset(0).format('YYYY-MM-DD HH:mm:ss.SSS'), // 2026-04-16 07:56:40.000
              amount: winAmount,
              type: 'WIN',
              betType: 'MAIN_BET',
            },
          }),
          jackPot: {
            contributionAmount: '0',
            winAmount: 0,
          },
          ...(this.constantTxnData.gameType === 'LIVE' && (isMultiBets ? {
            betSelections,
          } : {
            gamingDetails: {
              betSelections: [
                {
                  type: 'BAC_PLAYER',
                  betAmount: `${betAmount}`,
                  winAmount: `${winAmount}`,
                  sideBet: 'false',
                },
              ],
            },
          })),
        },
      }
    })

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${txnId}`, // 116314359
      roundId: `${this.roundIdPrefix}_${roundId}#${this.roundIdSufix}`, // live_87617990094#d08d86cb
      gameInfo: this.constantGameInfo,
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
